import React from 'react';
import { useSelector } from 'react-redux';
import { Icon } from 'ui';
import { pluralize } from 'utils/string_utils';
import Step from './Step';
import renderDust from './Dust';

const CompletedIndicator = () => {
  return (
    <div className="JourneyContentStepIndicator">
      <Icon className="PathContentStep-icon" name="correct" key="1" />
      {renderDust()}
    </div>
  );
};

const Completed = ({ isExpanded, setExpanded }) => {
  const { steps, completedSteps } = useSelector(state => state);
  const journeyCompleted = steps.length === completedSteps;

  const completeStepsArray = steps
    .slice(0, completedSteps)
    .map((step, index) => (
      <Step step={step} index={index + 1} key={step.stepId} />
    ));

  return (
    <div className="JourneyCompleted">
      <div className="JourneyCompleted-title">
        <CompletedIndicator />
        <button
          type="button"
          className="u-resetBtn JourneyCompleted-button"
          onClick={() => setExpanded(prev => !prev)}
        >
          {journeyCompleted
            ? t('journeys.viewer.completed_all_steps_message')
            : `${completedSteps} ${pluralize(
                completedSteps,
                'Step',
                'Steps',
              )} Completed`}
          <Icon
            name={isExpanded ? 'caret_down' : 'caret_right'}
            className="ml-4"
          />
        </button>
      </div>
      {isExpanded && (
        <div className="JourneyCompleted">{completeStepsArray}</div>
      )}
    </div>
  );
};

export default Completed;
